export default __webpack_public_path__ + "static/media/s4.bcfdf0ea.png";